import { render, staticRenderFns } from "./FactorValueFormBody.vue?vue&type=template&id=65000a62&scoped=true"
import script from "./FactorValueFormBody.vue?vue&type=script&lang=js"
export * from "./FactorValueFormBody.vue?vue&type=script&lang=js"
import style0 from "./FactorValueFormBody.vue?vue&type=style&index=0&id=65000a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65000a62",
  null
  
)

export default component.exports